import axios from 'axios';
import { FETCH_USER, UPDATE_PROFILE } from './types';
import { apiError, apiSuccessMessage, hasToken, headerConfig } from './utils-actions';
import { logout } from './auth-actions';
import { API_URL } from '../config/environment-variables';
import { loginUserFromResponse } from './onboarding-actions';

const ENDPOINT_URL = `${API_URL}/user`;

export function fetchUserDetails() {
  return dispatch => {
    if (hasToken()) {
      axios.get(`${ENDPOINT_URL}/profile`, headerConfig())
        .then(response => {
          dispatch({
            type: FETCH_USER,
            payload: response.data,
          });
        })
        .catch(response => {
          dispatch(logout());
          dispatch(apiError('Unable to fetch profile.', response));
        });
    }
  };
}

export function updateAppUserSettings(values) {
  return dispatch => axios.put(`${ENDPOINT_URL}/profile`, values, headerConfig())
    .then(response => {
      dispatch({
        type: UPDATE_PROFILE,
        payload: response.data,
      });
      dispatch(fetchUserDetails());
      dispatch(apiSuccessMessage('Account settings updated'));
    })
    .catch(response => {
      dispatch(apiError('Unable to update account settings.', response));
    });
}

export function updatePasswordSettings(actionId, values, form) {
  return dispatch => axios.put(`${ENDPOINT_URL}/password/update`, values, headerConfig())
    .then((response) => {
      dispatch(apiSuccessMessage('Password changed successfully', actionId));
      loginUserFromResponse(dispatch, response);
    })
    .catch(error => {
        form.setSubmitting(false);
        dispatch(apiError(null, error, actionId));
      },
    );
}
